export default __webpack_public_path__ + "static/B0263-12989b24bcfc40a508f97aa7c6eab230.png";